import * as React from 'react'
import { AppRoutes } from '@repo/web-utils/app-routes'
import {
  PaperCrafringTopicIcon,
  SeasonalCraftsTopicIcon,
  KidsCraftsTopicIcon,
  KnittingTopicIcon,
  HalloweenIcon,
  SellingOnEtsyIcon,
  PrintingOnDemandIcon,
  WeddingsIcon,
} from 'primitives/icons/topics-icons'

import {
  CricutTopicIcon,
  LaserCuttingTopicIcon,
  RhinestonesTopicIcon,
  VinylTopicIcon,
} from './../assets/icons/index'

export interface ClubhouseItem {
  id: number
  title: string
  slug: string
  href: string
  icon: React.ReactElement<unknown>
  bgColor: string
  bgColorHex: string
  iconColor: string
  textColor: string
  lightBgColorHex?: string
}

export const getClubhouseDetails = (slug: string) => {
  return CLUBHOUSES.find(ch => ch.slug === slug)
}

export const CLUBHOUSES: ClubhouseItem[] = [
  {
    id: 1,
    title: 'Cricut',
    slug: 'cricut',
    href: AppRoutes.CRICUT,
    icon: <CricutTopicIcon className="size-full" />,
    bgColor: 'bg-[#59B89D]',
    bgColorHex: '#59B89D',
    iconColor: '#31AE87',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#DBEFE9',
  },
  {
    id: 2,
    title: 'Xtool',
    slug: 'xtool',
    href: AppRoutes.XTOOL,
    icon: <LaserCuttingTopicIcon className="h-full w-full" />,
    bgColor: 'bg-[#F57F16]',
    bgColorHex: '#F57F16',
    iconColor: '#D66027',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FEECDD',
  },
  {
    id: 3,
    title: 'Siser',
    slug: 'siser',
    href: AppRoutes.SISER,
    icon: <VinylTopicIcon className="size-full" />,
    bgColor: 'bg-[#C41279]',
    bgColorHex: '#C41279',
    iconColor: '#65BC46',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FFE5F4',
  },
  {
    id: 4,
    title: 'Rhinestones',
    slug: 'rhinestones',
    href: AppRoutes.RHINESTONES,
    icon: <RhinestonesTopicIcon className="size-full" />,
    bgColor: 'bg-[#00ABAB]',
    bgColorHex: '#00ABAB',
    iconColor: '#E7B821',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#D3F8F8',
  },
  {
    id: 5,
    title: 'Christmas',
    slug: 'christmas',
    href: AppRoutes.CHRISTMAS,
    icon: <SeasonalCraftsTopicIcon className="h-full w-full" />,
    bgColor: 'bg-[#4208D9]',
    bgColorHex: '#4208D9',
    iconColor: '#AF2125',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#E7DEFE',
  },
  {
    id: 6,
    title: 'Paper-Crafts',
    slug: 'paper-crafts',
    href: AppRoutes.PAPER_CRAFTS,
    icon: <PaperCrafringTopicIcon className="h-full w-full" />,
    bgColor: 'bg-[#F4B91F]',
    bgColorHex: '#F4B91F',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FFF0CC',
  },
  {
    id: 7,
    title: 'Kids crafts',
    slug: 'kids-crafts',
    href: AppRoutes.KIDS_CRAFTS,
    icon: <KidsCraftsTopicIcon className="h-full w-full" />,
    bgColor: 'bg-[#C41279]',
    bgColorHex: '#C41279',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FFE5F4',
  },
  {
    id: 8,
    title: 'Knitting',
    slug: 'knitting',
    href: AppRoutes.KNITTING,
    icon: <KnittingTopicIcon className="h-full w-full" />,
    bgColor: 'bg-[#00ABAB]',
    bgColorHex: '#00ABAB',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#D3F8F8',
  },
  {
    id: 9,
    title: 'Halloween',
    slug: 'halloween',
    href: AppRoutes.CLUBHOUSE_HALLOWEEN,
    icon: <HalloweenIcon className="h-full w-full" />,
    bgColor: 'bg-[#F57F16]',
    bgColorHex: '#F57F16',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FEECDD',
  },
  {
    id: 10,
    title: 'Selling on Etsy',
    slug: 'selling-on-etsy',
    href: AppRoutes.SELLING_ON_ETSY,
    icon: <SellingOnEtsyIcon className="h-full w-full" />,
    bgColor: 'bg-[#4208D9]',
    bgColorHex: '#4208D9',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#E7DEFE',
  },
  {
    id: 11,
    title: 'Print on demand',
    slug: 'print-on-demand',
    href: AppRoutes.PRINT_ON_DEMAND,
    icon: <PrintingOnDemandIcon className="h-full w-full" />,
    bgColor: 'bg-[#F4B91F]',
    bgColorHex: '#F4B91F',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#FFF0CC',
  },
  {
    id: 12,
    title: 'Weddings',
    slug: 'weddings',
    href: AppRoutes.WEDDINGS,
    icon: <WeddingsIcon className="h-full w-full" />,
    bgColor: 'bg-[#68B8A1]',
    bgColorHex: '#68B8A1',
    iconColor: '#5060AC',
    textColor: 'text-[#4E525C]',
    lightBgColorHex: '#DCF4EF',
  },
]
